"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlanboxModal;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _asyncModal = _interopRequireDefault(require("../../../elements/other/shared-modal/async-modal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function PlanboxModal({
  cta: modalCTA,
  planbox: {
    id: sitecoreID
  },
  modalCloseAriaLabel,
  retryText,
  portalElem
}) {
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const loadPlanBoxModule = async templateName => {
    /* istanbul ignore next */
    if (templateName === 'SimplePlanBoxSection') {
      return await Promise.resolve().then(() => _interopRequireWildcard(require('../simple-plan-box-section')));
    }
    return await Promise.resolve().then(() => _interopRequireWildcard(require('../../product-merchandising/plan-box-section-subscription')));
  };
  const handleClick = () => {
    setShowModal(true);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_asyncModal.default, {
    sitecoreID: sitecoreID,
    retryText: retryText,
    moduleLoader: loadPlanBoxModule,
    modalCTA: modalCTA,
    modalCloseAriaLabel: modalCloseAriaLabel,
    portalElem: portalElem,
    modalHash: "planbox-modal",
    show: showModal,
    onClose: () => setShowModal(false)
  }), /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: [{
      isPromo: false,
      onClick: handleClick,
      href: '#',
      ...modalCTA,
      ['data-cy']: 'modal-trigger',
      dataCy: 'modal-trigger'
    }]
  }));
}
PlanboxModal.propTypes = {
  cta: _propTypes.default.object,
  modalCloseAriaLabel: _propTypes.default.string,
  retryText: _propTypes.default.string,
  planbox: _propTypes.default.object,
  portalElem: _propTypes.default.object
};